import TopBanner from '../TopBanner';
import Indicator from '../Indicator';
import {HBox, VBox} from '../Box';
import {Reference} from '../../Structure';

import {React, Component, component, classnames} from '../component';


export default class Page extends Component {

  static propTypes = {
    data: React.PropTypes.instanceOf(Reference).isRequired
  };

  renderLoading(className) {
    const cls = classnames('Page', 'Page--loading', className);
    return (
      <div className={cls}>
        <TopBanner data={this.props.data} />
        {this.renderPreloader()}
      </div>
    )
  }

  renderPreloader(className) {
    const cls = classnames('Page-Preloader', className);
    return (
      <div className={cls}>
        <Indicator className='Page-Indicator' />
      </div>
    );
  }

}

export {Page, Component, React, TopBanner, Indicator, HBox, VBox, component, classnames};



// WEBPACK FOOTER //
// ./src/components/pages/Page.js